// import logo from './logo.svg';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";  
import Home from "./pages/home/Home"; 
import HeaderTop from "./Header";
import Footer from "./Footer"; 
import CmsPage from "./pages/CmsPage";
import ToursList from "./pages/ToursList";
import ToursDetails from "./pages/ToursDetails"; 
import VideoGallery from "./pages/VideoGallery";
import PhotoGalleryCategories from "./pages/PhotoGalleryCategories";
import PhotoGalleryPage from "./pages/PhotoGalleryPage";
import TestimonialForm from "./pages/TestimonialForm"; 
import FeedbackPage from "./pages/FeedbackPage";
import ToursPackagesAll from "./pages/ToursPackagesAll";

function App() {
  return (
      // basename="/kashijourneys/"
    <Router>
    <HeaderTop/>
      <Routes>
        <Route path="/" element={<Home />} />  
        <Route path="/:slug" element={<CmsPage key={window.location.pathname} />} /> 
        <Route path="/tours" element={<ToursPackagesAll />} /> 
        <Route path="/our-tours/:categorySlug" element={<ToursList />} /> 
        <Route path="/:categorySlug/:slug" element={<ToursDetails />} /> 
        <Route path="/photo-gallery" element={<PhotoGalleryCategories />} /> 
        <Route path="/photo-gallery/:catId" element={<PhotoGalleryPage />} />
        <Route path="/video-gallery" element={<VideoGallery />} /> 
        <Route path="/feedback" element={<FeedbackPage />} /> 
        <Route path="/feedback-form" element={<TestimonialForm />} /> 
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
